import { createDynamicSlice } from ".";
import { fetchClientEscalationsThunk } from "../thunks/clientEscalationsThunk";

export const clientEscalationsSlice = createDynamicSlice({
  name: "clientEscalations",
  thunk: fetchClientEscalationsThunk,
  listMode: true,
  resetActionName: "resetClientEscalations",
});

export const clientEscalationsReducer = clientEscalationsSlice.reducer;
export const { resetClientEscalations } = clientEscalationsSlice.actions;
